"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var Icon_1 = require("components/Icon");
require("./style.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('status', 'setStatus', 'LOADING'), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var _this = this;
        if (this.props.hasLogo) {
            var image = new Image();
            image.onload = function () {
                _this.props.setStatus('LOADED');
            };
            image.onerror = function () {
                _this.props.setStatus('ERROR');
            };
            image.src = "".concat(__APIBASEURL__, "api/customer/").concat(this.props.customerUUID, "/customer-image");
        }
        else {
            this.props.setStatus('ERROR');
        }
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    if (props.status === 'LOADED') {
        return (React.createElement("span", { className: 'sok-customer-logo has', style: {
                backgroundImage: "url(".concat(__APIBASEURL__, "api/customer/").concat(props.customerUUID, "/customer-image)")
            } }));
    }
    else {
        return (React.createElement("span", { className: classNames('fa-stack sok-customer-logo none') },
            React.createElement(Icon_1.Icon, { className: 'fa-circle fa-stack-1x' }),
            props.status !== 'LOADING' && (React.createElement(Icon_1.Icon, { className: 'fa-building fa-stack-1x' }))));
    }
});
